import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// const state = { token: localStorage.getItem('token')}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token")
    // ajaxUrl: 'http://45.7.231.193:8084/api/',
    // test: 'teeeest',
  },
  mutations: {},
  actions: {}
});
